<div class="notification-title">{{getReviewStep()}}</div>
<div class="notification-info">
  <p>
    <app-file-icon class="file-type-icon" size="30px" fileSuffix="{{fileSuffix}}"></app-file-icon>
    <strong class="doc-name" appFsMask>{{file.originalDocumentName}}</strong>
    @if (file.statementDate && file.reportedDate) {
      | Period: {{file.statementDate | formatDate }} - {{file.reportedDate | dateToPeriod}}.
    }
  </p>
</div>
@if (readyForReview) {
  <button class="btn btn-primary" (click)="routeToReview()">Review</button>
}